//此帳號否有此權限
function hasModuleName(functionRoles, item) {
  return functionRoles.find((it) => it.moduleName == item.moduleName) != null
}

function hasFunctionName(functionRoles, item) {
  return (
    functionRoles.find((it) => it.functionName == item.functionName) != null
  )
}
function hasScope(functionRoles, item) {
  return functionRoles.find((it) => item.scope.indexOf(it) >=0 ) != null
}
import convert from './convert'

export default {
  convert,
  hasScope,
  hasModuleName,
  hasFunctionName,
}
